import styles from "./styles.module.css";
import Image from "next/image";
import { ImageProps } from "types/Image.type";

export default function ImageContainer({
  image,
  alt,
  title,
  imageStyle,
  containerStyle,
  fill,
  width,
  height,
  sizes
}: ImageProps) {
  return (
    <figure className={containerStyle}>
      <Image
        src={image}
        {...(fill ? { fill } : { width, height })}
        sizes={sizes}
        alt={alt}
        title={title}
        className={`${imageStyle} ${styles.image}`}
      />
    </figure>
  );
}
